import { Loader2 } from "lucide-react";
import FilePreview from "@/modern/components/file-preview";
import { useFileDetailModal } from "../context/FileDetailModalContext";
import { isImageFileTyped } from "@/react/components/entityViews/files/components/FileHelpers";
import { getFileExtension } from "@/modern/utils";

export const ImageViewer = () => {
  const {
    file,
    imageLoading,
    showSpinner,
    displayedImageUrl,
    currentImageUrl,
    handleLoadComplete,
  } = useFileDetailModal();

  if (!file) return null;

  const isPDF = getFileExtension(file.name) === "pdf";
  const isImage = isImageFileTyped(file) && !isPDF;

  // For first load when displayedImageUrl is undefined, use currentImageUrl
  // After first load, always use displayedImageUrl to show previous image while new one loads
  const srcToDisplay = displayedImageUrl || (isImage ? currentImageUrl : undefined);

  // Only preload if we have a different URL and displayedImageUrl is set (not first load)
  const shouldPreload = isImage && currentImageUrl && displayedImageUrl && currentImageUrl !== displayedImageUrl;

  return (
    <div className="group relative flex h-full w-full items-center justify-center overflow-hidden">
      {/* Loading spinner overlay - shows after 300ms - only for images */}
      {isImage && showSpinner && imageLoading && (
        <div className="absolute inset-0 z-30 flex items-center justify-center bg-background/80 backdrop-blur-sm animate-in fade-in duration-200">
          <Loader2 className="h-12 w-12 animate-spin text-foreground" />
        </div>
      )}

      {/* Display file preview - shows the displayedImageUrl (previous image while loading new one) */}
      <FilePreview
        file={file}
        src={srcToDisplay}
        className="relative z-10 h-full w-full max-h-full object-contain rounded-md"
        fileIconClassName="size-24"
        showName={true}
        disableLoadingState={true}
        enableVideoAudioRendering={true}
        isUseFileQueryParam={true}
      />

      {/* Preload new image invisibly - only when navigating (not first load) */}
      {shouldPreload && (
        <img
          src={currentImageUrl + "?v=" + Date.now()}
          alt=""
          className="hidden"
          onLoad={handleLoadComplete}
          onError={handleLoadComplete}
        />
      )}
    </div>
  );
};
